import {
  FETCH_BALANCE_LOADING,
  FETCH_BALANCE_SUCCESS,
  FETCH_BALANCE_ERROR,
  UPDATE_USER_BALANCE_LOADING,
  UPDATE_USER_BALANCE_SUCCESS,
  UPDATE_USER_BALANCE_ERROR,
  FETCH_HISTORY_LOADING,
  FETCH_HISTORY_SUCCESS,
  FETCH_HISTORY_ERROR,
  ADD_BALANCE_SUCCESS,
  ADD_BALANCE_ERROR,
  DELETE_BALANCE_SUCCESS,
  DELETE_BALANCE_ERROR,
  FETCH_USER_HISTORY_LOADING,
  FETCH_USER_HISTORY_SUCCESS,
  FETCH_USER_HISTORY_ERROR
} from '../Types/balanceTypes';

const initialState = {
  data: [],
  historyData: [],
  error: null,
  success: null,
  isLoading: false,
  updateLoading: false,
  updateError: null,
  loading: false,
  balanceData: null,
};

const balanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BALANCE_LOADING:
      return { ...state, isLoading: true, error: null };
    case FETCH_BALANCE_SUCCESS:
      return { ...state, isLoading: false, data: action.payload, error: null };
    case FETCH_BALANCE_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case FETCH_HISTORY_LOADING:
      return { ...state, isLoading: true };
    case FETCH_HISTORY_SUCCESS:
      return { ...state, isLoading: false, data: action.payload, error: '' };
    case FETCH_HISTORY_ERROR:
      return { isLoading: false, data: [], error: action.payload };

    case UPDATE_USER_BALANCE_LOADING:
      return { ...state, updateLoading: true, updateError: null };
    case UPDATE_USER_BALANCE_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        data: state.data.map(item => (item._id === action.payload._id ? action.payload : item)),
        updateError: null
      };
    case UPDATE_USER_BALANCE_ERROR:
      return { ...state, updateLoading: false, updateError: action.payload };

    case ADD_BALANCE_SUCCESS:
      return { ...state, data: [...state.data, action.payload] };
    case ADD_BALANCE_ERROR:
      return { ...state, error: action.payload };

    case DELETE_BALANCE_SUCCESS:
      return {
        ...state,
        data: state.data.filter(item => item._id !== action.payload.id)
      };
    case DELETE_BALANCE_ERROR:
      return { ...state, error: action.payload };

    case FETCH_USER_HISTORY_LOADING:
      return { ...state, loading: true, historyData: [] };
    case FETCH_USER_HISTORY_SUCCESS:
      return { ...state, loading: false, historyData: action.payload };
    case FETCH_USER_HISTORY_ERROR:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default balanceReducer;
